import React from 'react';
import './About.css';
import { about_stats } from '../../constants/data';
import { FaHome, FaBuilding, FaKey, FaHandshake } from 'react-icons/fa';

const About = () => {
  const houseIcons = [
    { icon: <FaHome size={100} className="text-brown" />, label: "Casas" },
    { icon: <FaBuilding size={100} className="text-brown" />, label: "Edificios" },
    { icon: <FaKey size={100} className="text-brown" />, label: "Alquileres" },
    { icon: <FaHandshake size={100} className="text-brown" />, label: "Ventas" }
  ];

  return (
    <div className='about section-p'>
      <div className='container'>
        <div className='about-content'>
          <div className='section-title'>
            <h3 className='text-brown'>
              Tu Inquilino <span className='text-dark'>Ideal</span>
            </h3>
            <p className='text mx-auto'>
               Nuestra amplia gama de servicios te permite aprovechar al máximo el potencial del mercado inmobiliario. Ya sea que necesites gestión de alquileres, inversiones o consultoría, nuestro equipo experto está aquí para ti.
            </p>
          </div>

          <div className='about-icons grid'>
            {houseIcons.map((item, index) => (
              <div className='icon-item text-center' key={index}>
                <div className='icon-container'>
                  {item.icon}
                </div>
                <p className='icon-label'>{item.label}</p>
              </div>
            ))}
          </div>

          <div className='about-grid grid'>
            {about_stats.map((about_stat, index) => {
              return (
                <div className='about-item text-center flex' key={index}>
                  <div className='about-item-icon'>
                    <img src={about_stat.image} alt='' className='rounded-img' />
                  </div>
                  <div className='about-item-text text-left'>
                    <h3 className='fs-24 ls-2'>{about_stat.value}</h3>
                    <p className='text'>{about_stat.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
